import { request } from "../../../services/api"
import type { BaseApiResponse, BasePagination } from "../../../types/api.ts"
import type {
  MessageTemplate,
  PersonalTemplate,
  PlaceholderGroup,
  TemplateWrite
} from "../types/communication.types.ts"

const COMPANY = "/templates-management/email-templates"
const PERSONAL = "/crm/lead-email-templates"

// GETs come back bare; writes are enveloped — read them with `unwrapEnvelope`.

export const getCompanyTemplates = () =>
  request.api.get<BasePagination<MessageTemplate>, BaseApiResponse<void>>(
    `${COMPANY}/`,
    {
      page_size: 500
    }
  )

export const createCompanyTemplate = (payload: TemplateWrite) =>
  request.api.post<BaseApiResponse<MessageTemplate>, BaseApiResponse<void>>(
    `${COMPANY}/`,
    payload
  )

export const updateCompanyTemplate = (
  id: string,
  payload: Partial<TemplateWrite>
) =>
  request.api.patch<BaseApiResponse<MessageTemplate>, BaseApiResponse<void>>(
    `${COMPANY}/${id}/`,
    payload
  )

export const deleteCompanyTemplate = (id: string) =>
  request.api.delete<BaseApiResponse<null>, BaseApiResponse<void>>(
    `${COMPANY}/${id}/`
  )

export const getPersonalTemplates = () =>
  request.api.get<
    BasePagination<PersonalTemplate> | PersonalTemplate[],
    BaseApiResponse<void>
  >(`${PERSONAL}/`, { page_size: 500 })

export const createPersonalTemplate = (
  payload: Pick<TemplateWrite, "name" | "subject" | "body">
) =>
  request.api.post<BaseApiResponse<PersonalTemplate>, BaseApiResponse<void>>(
    `${PERSONAL}/`,
    payload
  )

export const updatePersonalTemplate = (
  id: string,
  payload: Partial<Pick<TemplateWrite, "name" | "subject" | "body">>
) =>
  request.api.patch<BaseApiResponse<PersonalTemplate>, BaseApiResponse<void>>(
    `${PERSONAL}/${id}/`,
    payload
  )

export const deletePersonalTemplate = (id: string) =>
  request.api.delete<BaseApiResponse<null>, BaseApiResponse<void>>(
    `${PERSONAL}/${id}/`
  )

export const getPlaceholders = () =>
  request.api.get<{ groups: PlaceholderGroup[] }, BaseApiResponse<void>>(
    "/communication/placeholders/"
  )
